/// <reference types="vite/client" />

export const INSTANCE_URL = import.meta.env.VITE_INSTANCE_URL;
export const USE_SHADOW_DOM = import.meta.env.VITE_USE_SHADOW_DOM === 'true';
export const API_TIMEOUT = Number(import.meta.env.VITE_API_TIMEOUT) || 10000;
export const POS_ONTOLOGY_ID = import.meta.env.VITE_POS_ONTOLOGY_ID;
export const POS_COLLECTION_ID = import.meta.env.VITE_POS_COLLECTION_ID;

export const LOAN_OFFICER_API_BASE_URL = import.meta.env
  .VITE_LOAN_OFFICER_API_BASE_URL;
export const SINGLE_LOAN_OFFICER_API_BASE_URL = import.meta.env
  .VITE_SINGLE_LOAN_OFFICER_API_BASE_URL;
export const BRANCH_API_BASE_URL = import.meta.env.VITE_BRANCH_API_BASE_URL;
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

export const CLIENT_ID = import.meta.env.VITE_CLIENT_ID || 'REVOLUTION';
export const POS_APP_REDIRECT_BASE_URL = import.meta.env
  .VITE_POS_APP_REDIRECT_BASE_URL;

// http://localhost:5173/pos-app/quickloan/application?role=borrower&sessionId=<SESSION_ID>&token=<ACCESS_TOKEN>
